import * as React from "react";
import { Icon } from "./Icon.js";

type Format = "csv" | "pdf";

const OPTIONS: { format: Format; title: string; description: string }[] = [
  {
    format: "csv",
    title: "CSV",
    description:
      "Spreadsheet-friendly. Open in Excel, Numbers, or Google Sheets to filter, sort, or pivot the raw data.",
  },
  {
    format: "pdf",
    title: "PDF",
    description:
      "Printable report. Share or archive a snapshot of the current view, headed with the filters and sort that produced it.",
  },
];

export function ExportModal({
  hrefFor,
  onClose,
}: {
  hrefFor: (format: Format) => string;
  onClose: () => void;
}) {
  React.useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal card fade-in"
        style={{ maxWidth: 460 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-h">
          <div>
            <div className="modal-title">Export</div>
            <div className="modal-sub">Choose a format for the current view.</div>
          </div>
          <button className="icon-btn" onClick={onClose} aria-label="Close">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="modal-body">
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {OPTIONS.map((opt) => (
              <a
                key={opt.format}
                className="card export-option"
                href={hrefFor(opt.format)}
                download
                onClick={onClose}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 12,
                  padding: 12,
                  textDecoration: "none",
                  color: "inherit",
                  cursor: "pointer",
                }}
              >
                <div
                  className="avatar"
                  style={{ background: "#1a8fbf", width: 32, height: 32, flexShrink: 0 }}
                >
                  <Icon name="download" size={14} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 2 }}>
                    {opt.title}
                  </div>
                  <div style={{ fontSize: 12.5, color: "var(--ink-700)", lineHeight: 1.4 }}>
                    {opt.description}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
        <div className="modal-foot">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
